import { ApiProperty } from "@nestjs/swagger";

export class ItemBySubcategory {
    @ApiProperty()
    itemSubCategoryId : number;
}